import React from "react"
import { Flex, Box } from "@rebass/grid/emotion"

import { TextElementNova } from "@nutrafol/nutrafol-ui-kit/dist/TextElementNova"
import { ButtonNova } from "@nutrafol/nutrafol-ui-kit/dist/ButtonNova"

import Section from "../section/section"
import QuizBannerAnimation from "./quizbanneranimation"

import { AnimationArea } from "./quizbanner.styled"

const QuizBanner = ({ data }) => {
  const handleCtaClick = () => {
    setTimeout(() => {
      window.location = `${process.env.GATSBY_MAGENTO_URL}quiz/`
    }, 500)
  }

  return (
    <Section>
      <Flex
        flexDirection={["column", "column", "column", "row"]}
        className="rounded overflow-hidden bg-nova-base-black"
      >
        <Flex
          className="relative z-1 bg-nova-base-black gap-8 sm:gap-10 md:gap-8"
          width={[1, 1, 1, 1 / 2]}
          px={[24, 24, 32, 80]}
          pt={[40, 40, 0, 80]}
          pb={[40, 40, 48, 80]}
          order={[2, 2, 2, 1]}
          mt={["-1px", null, null, 0]}
          flexDirection={["column", "column", "row", "column"]}
          alignItems={["flex-start", "flex-start", "center", "flex-start"]}
        >
          <Box flex="1" maxWidth={[400, null, 425, 400]} mx={["auto", null, 0]}>
            <TextElementNova
              element="h2"
              text={
                data?.bannerText ||
                "Not sure where to start? Uncover what you need to support hair growth."
              }
              className="Subtitle-20-Dia-Normal text-nova-base-white text-center sm:text-left"
            />
          </Box>
          <Box mx={["auto", null, 0]} className="sm:!ml-auto md:!ml-0">
            <ButtonNova
              onClick={handleCtaClick}
              label={"Take the Quiz"}
              icon={"Right"}
              level={"Primary"}
              className="quiz-cta"
              trackObject={{
                destination: "/quiz/",
                module_location: "mid_fold",
                module_name:
                  data?.bannerText ||
                  "Not sure where to start? Uncover what you need to support hair growth.",
                type: "button",
                text: "Take the Quiz",
              }}
            />
          </Box>
        </Flex>
        <AnimationArea width={[1, 1, 1, 1 / 2]} order={[1, 1, 1, 2]}>
          <QuizBannerAnimation />
        </AnimationArea>
      </Flex>
    </Section>
  )
}

export default QuizBanner
